import { ReactNode } from 'react'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import { ICompliance } from '@/types/tasksApprovals'

import Status from './components/status'

const Task = ({ icon, item, onClick, isLastItem }: { icon: ReactNode; isLastItem?: boolean; item: ICompliance; onClick: () => void }) => {
    const padding = isLastItem ? ['16px 8px', '16px 16px 0 16px'] : ['16px 8px', '16px']
    return (
        <Flex
            key={item.title}
            alignItems="center"
            borderBottom={isLastItem ? '' : '1px solid'}
            borderColor="rgba(84, 79, 64, 0.12)"
            cursor="pointer"
            onClick={onClick}
        >
            <Box p="24px 8px">{icon}</Box>
            <Box p={padding}>
                <Text fontWeight="bold" fontSize="14px" lineHeight="20px" wordBreak="break-word">
                    {item.description}
                </Text>
                <Status item={item} />
            </Box>
        </Flex>
    )
}

export default Task
